<template>
  <el-dialog id="dialogReturnCameras" title="Возврат камер" :visible="visible" @close="onClose">
    <span>{{ messageText }}</span>
    <el-form id="formReturnCameras" label-position="left" label-width="120px">
      <el-form-item label="Принудительно">
        <el-switch
          v-model="force"
          :active-value="1"
          :inactive-value="0"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button id="closeServer" @click="onClose">Отменить</el-button>
      <el-button id="submitServer" :loading="loading" type="primary" @click="onSave">{{ confirmButtonText }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

export default {
  name: "ReturnCamerasDialog",
  props: {
    idTransfer: {
      type: Number,
      default: null,
    },
    visible: {
      type: Boolean,
      default: false,
    },
    messageText: {
      type: String,
      default: ""
    },
    confirmButtonText: {
      type: String,
      default: "Вернуть камеры",
    },
    loading: {
      type: Boolean,
    },
  },
  data() {
    return {
      transferId: null,
      force: 0,
    };
  },
  watch: {
    idTransfer(idTransfer) {
      this.transferId = idTransfer;
    },
  },
  methods: {
    onSave() {
      this.$emit("save", this.transferId, this.force);
    },
    onClose() {
      this.$emit("close");
    },
  },
};
</script>
